<template>
  <div>
    <!-- Modal/Delete component starts -->
    <DeleteModal
      :disabledButton="disabledButton"
      @cancel="closeModal('delete')"
      @deleteConfirmed="deleteSingleZone"
    />
    <!-- Modal/Delete component ends -->

    <!-- Modal/Deleted Successfully component starts -->
    <deleted-modal />
    <!-- Modal/Deleted Successfully component ends -->
    <div>
      <div
        class="company-info"
        :style="{
          'background-image': 'url(' + `${resizer(zoneBackground(singleZone))}` + ')',
        }"
      >
        <div class="backgroundLayer absolute"></div>
        <div class="grid-box">
          <div class="back-arrow" @click="backRouteHandler">
            <back-arrow color="white" width="24" height="24" class="right-back-arrow" />
          </div>
          <div class="column-arrange">
            <div class="header-section">
              <div class="company-name">{{ singleZone.name }}</div>
            </div>
            <div class="row mt-20 gap-x-28">
              <div class="row inner-dashboard-card gap-x-20">
                <div class="dashed_border-info w-78 h-5">
                  <span class="dashed_border-header">{{ singleZone.sub_zones_count }}</span>
                  <span class="dashed_border-content">{{ $t('zones') }}</span>
                </div>
                <div class="dashed_border-info w-78 h-5">
                  <span class="dashed_border-header">{{ singleZone.devices_count }}</span>
                  <span class="dashed_border-content">{{ $t('devices') }}</span>
                </div>
              </div>
            </div>
          </div>
          <div class="zone-menu">
            <div class="flex flex-row-reverse">
              <v-dropdown
                placement="bottom-end"
                class="zone-menu-alignment"
                v-if="hasPermission('zones_and_devices_management')"
              >
                <div class="notification-box cursor-pointer">
                  <vector color="#fff" />
                </div>

                <template #popper>
                  <ul class="p-10">
                    <li
                      class="popover-group_li hover-popover-group_li"
                      v-close-popper="true"
                      @click="$router.push({ name: 'EditZone', params: { id: singleZone.id } })"
                    >
                      <div class="popover_classes">
                        <div class="flex-grow w-2/3">
                          {{ $t('edit') }}
                        </div>
                        <edit class="popover-img" width="16" height="16" />
                      </div>
                    </li>
                    <li
                      class="popover-group_li hover-popover-group_li"
                      v-close-popper="true"
                      @click="openModal('delete')"
                    >
                      <div class="popover_classes">
                        <div class="flex-grow w-2/3">
                          {{ $t('delete') }}
                        </div>
                        <trash class="popover-img" width="16" height="16" />
                      </div>
                    </li>
                  </ul>
                </template>
              </v-dropdown>
            </div>
          </div>
        </div>
      </div>
      <div class="pb-0 company-tab">
        <portal-target name="dashboard-header" />
      </div>
    </div>
    <div class="card-box pb-20 mt-16">
      <base-tab :tabList="tabList" @onTabChange="onTabChange" data-cy="tab-data">
        <template #tabPanel-subZones>
          <div class="tab-toolbar">
            <div class="flex-1">
              <h2 class="tab-title">{{ $t('subzones') }}</h2>
            </div>
            <div class="flex gap-x-20">
              <base-button
                buttonType="primary"
                width="110"
                height="44"
                class="sm:w-90"
                radius="default"
                :hasIcon="true"
                v-if="
                  hasPermission('zones_and_devices_management') &&
                  singleZone.zones &&
                  singleZone.zones.length > 0
                "
                @click.native="
                  $router.push({
                    name: 'AddSubZone',
                    params: { id: zoneId, subZoneParentId: singleZone.id },
                    query: { name: singleZone.name },
                  })
                "
              >
                <template #text>
                  <span class="text-14">
                    {{ $t('add') }}
                  </span>
                </template>
                <template #icon>
                  <img :src="Add" alt="add" />
                </template>
              </base-button>
              <base-simple-search-box
                id="s_sub_zone"
                type="Zones"
                @searchedText="getSearchedText"
                @searchedIn="getSearchedType"
                customStyle="sm:w-52"
                height="40"
              />
            </div>
          </div>
          <div class="tab-content mt-20">
            <!-- zone component start -->
            <div v-if="isLoading && isLoading.name === 'subZones'" class="zone-card">
              <div
                v-for="index in Math.floor(Math.random() * 16)"
                :key="index"
                class="zone-card-image"
              >
                <base-skeleton width="60" height="60" name="subZones" />
                <div class="flex flex-col gap-10">
                  <base-skeleton width="94" height="15" name="subZones" />
                  <base-skeleton width="78" height="12" name="subZones" />
                </div>
              </div>
            </div>
            <div v-else>
              <div v-if="singleZone.zones && singleZone.zones.length > 0">
                <div class="zone-card">
                  <div
                    class="zone-card-image"
                    v-for="zone in singleZone.zones"
                    :key="zone.id"
                    @click="getSingleZone(zone.id)"
                  >
                    <div
                      v-if="zone.image"
                      :style="{
                        'background-image': 'url(' + `${resizer(zone.image)}` + ')',
                      }"
                      class="w-60 h-60 bg-cover rounded"
                      @error="OnImageError"
                    ></div>
                    <img :src="brokenSrc()" alt="" class="w-60 h-60 bg-cover rounded"
                     v-else @error="OnImageError" />
                    <div class="flex flex-col">
                      <h3 class="text-sm font-bold truncate w-120">{{ zone.name }}</h3>
                      <h5 class="text-12 font-bold text-subtitle" v-if="zone.devices_count > 0">
                        {{ zone.devices_count }}
                        {{ $t('device') }}
                      </h5>
                    </div>
                  </div>
                </div>
              </div>
              <base-no-item-to-show v-else-if="isSearching" :message="$t('subzones')" />
              <div class="center my-110" v-else>
                <base-add-page
                  v-if="hasPermission('zones_and_devices_management')"
                  :message="$t('subzones')"
                  @click.native="
                    $router.push({
                      name: 'AddSubZone',
                      params: { id: zoneId, subZoneParentId: singleZone.id },
                      query: { name: singleZone.name },
                    })
                  "
                />
              </div>
            </div>
            <!-- zone component end -->
          </div>
        </template>
        <template #tabPanel-devices>
          <div class="tab-toolbar">
            <div class="flex-1">
              <h2 class="tab-title">{{ $t('devices') }}</h2>
            </div>
            <div class="flex gap-x-20">
              <base-button
                buttonType="primary"
                width="110"
                height="44"
                class="sm:w-90"
                radius="default"
                :hasIcon="true"
                v-if="hasPermission('zones_and_devices_management') && devices.length > 0"
                @click.native="$router.push({ name: 'AddDevice' })"
              >
                <template #text>
                  <span class="text-14">
                    {{ $t('add') }}
                  </span>
                </template>
                <template #icon>
                  <img :src="Add" alt="add" />
                </template>
              </base-button>
              <base-simple-search-box
                type="devices"
                id="sz_s_device"
                @searchedText="getSearchedText"
                @searchedIn="getSearchedType"
                customStyle="sm:w-52"
                height="40"
              />
            </div>
          </div>
          <div class="tab-content mt-20">
            <!-- device component start -->
            <div class="device-card" v-if="isLoading && isLoading.name === 'devices'">
              <div
                v-for="index in Math.floor(Math.random() * 16)"
                :key="index"
                class="device-card-main"
              >
                <div class="flex items-center gap-x-10 mb-10">
                  <base-skeleton width="60" height="60" name="devices" />
                  <div class="flex flex-col gap-10">
                    <base-skeleton width="94" height="15" name="devices" />
                    <base-skeleton width="78" height="12" name="devices" />
                  </div>
                </div>
                <base-skeleton width="265" height="32" name="devices" />
              </div>
            </div>
            <div v-else>
              <div v-if="devices && devices.length > 0">
                <div v-if="devices && devices.length > 0" class="mt-40">
                  <div class="device-card">
                    <div
                      class="device-card-main"
                      v-for="(device, index) in devices"
                      :key="index"
                      @click="goToReservationRoom(device)"
                    >
                      <div class="flex justify-between">
                        <div class="flex items-center gap-x-10">
                          <div
                            class="w-60 h-60 bg-tertiary rounded flex justify-center items-center"
                          >
                            <img :src="Device" alt="Device" class="block w-30 h-30" />
                          </div>
                          <div>
                            <h3 class="text-sm font-bold truncate w-102">{{ device.name }}</h3>
                            <h5 class="text-12 font-medium text-subtitle">
                              {{
                                device.reservable === 1 ? $t('conference_room') : $t('work_room')
                              }}
                            </h5>
                          </div>
                        </div>
                        <div>
                          <div class="card-header-icon-success" v-if="device.connected" />
                          <div class="card-header-icon-danger" v-else />
                        </div>
                      </div>

                      <div
                        class="flex justify-center pt-10"
                        @click.stop.prevent="
                          unlockDeviceHandler(device.id, device.name, device.can_unlock)
                        "
                      >
                        <base-button
                          radius="sm"
                          buttonType="success-opacity"
                          width="full"
                          height="32"
                          :disabled="device.can_unlock === false || device.can_unlock === null"
                        >
                          <template #text>
                            <div class="flex justify-center items-center gap-x-3">
                              <lock-icon
                                width="15"
                                height="15"
                                :color="
                                  device.can_unlock === false || device.can_unlock === null
                                    ? '#BDBEBF'
                                    : '#34C759'
                                "
                              />
                              <div class="text-sm">
                                {{ $t('unlock') }}
                              </div>
                            </div>
                          </template>
                        </base-button>
                      </div>
                    </div>
                  </div>
                  <base-paginate
                    :links="links"
                    @onPageChange="onPageChange"
                    type="devices"
                    class="my-50"
                  />
                </div>
              </div>
              <base-no-item-to-show v-else-if="isSearching" :message="$t('device')" />
              <div class="center my-110" v-else>
                <base-add-page
                  :message="$t('device')"
                  v-if="hasPermission('zones_and_devices_management')"
                  @click.native="$router.push({ name: 'AddDevice' })"
                />
              </div>
            </div>
            <!-- device component end -->
          </div>
        </template>
      </base-tab>
    </div>
    <unlock-device-modal @unlockDeviceConfirmation="unlockDevice" :device="unlockDeviceName" />
  </div>
</template>
<script>
import { mapGetters } from 'vuex';
import axiosConfig from '@/services/axios.config';
import { OnImageError, brokenSrc } from '@/utils/on-image-error';
import Lock from '@/assets/icons/svg/lock.svg';
import Add from '@/assets/icons/svg/white-add.svg';
import Vector from '@/assets/icons/vue/vector.vue';
import Edit from '@/assets/icons/vue/edit.vue';
import Trash from '@/assets/icons/vue/trash.vue';
import BaseTab from '@/components/base/BaseTab.vue';
import BaseSimpleSearchBox from '@/components/base/BaseSimpleSearchBox.vue';
import BaseNoItemToShow from '@/components/base/BaseNoItemToShow.vue';
import BaseAddPage from '@/components/base/BaseAddPage.vue';
import DeleteModal from '@/components/modals/DeleteModal.vue';
import DeletedModal from '@/components/modals/DeletedModal.vue';
import BaseSkeleton from '@/components/base/BaseSkeleton.vue';
import modalSwitcher from '@/utils/modal-switcher';
import serverErrorsHandler from '@/utils/serverErrorsHandler';
import BaseButton from '@/components/base/BaseButton.vue';
import BackArrow from '@/assets/icons/vue/backArrow.vue';
import Device from '@/assets/icons/svg/iot-device.svg';
import imageResizer from '@/utils/image-resizer';
import LockIcon from '@/assets/icons/vue/Lock.vue';
import UnlockDeviceModal from '@/components/modals/UnlockDeviceModal.vue';
import BasePaginate from '@/components/base/BasePaginate.vue';

export default {
  data() {
    return {
      Device,
      Add,
      Lock,
      OnImageError,
      brokenSrc,
      singleZone: {},
      me: {},
      zones: [],
      devices: [],
      tabList: ['subZones', 'devices'],
      currentPage: 1,
      searchType: 'subZones',
      currentType: 'subZones',
      zoneId: this.$route.params.id,
      isSearching: false,
      disabledButton: false,
      imageSize: 150,
      unlockDeviceId: -1,
      unlockDeviceName: '',
      links: {},
    };
  },
  components: {
    BaseTab,
    BaseSimpleSearchBox,
    BaseNoItemToShow,
    BaseAddPage,
    DeleteModal,
    DeletedModal,
    BaseSkeleton,
    Vector,
    Edit,
    Trash,
    BaseButton,
    BackArrow,
    LockIcon,
    UnlockDeviceModal,
    BasePaginate,
  },
  mounted() {
    if (this.$route.query.active) {
      this.currentType = this.$route.query.active;
    }
    this.onTabChange(this.currentType);
    this.getSingleZone(this.zoneId);
    this.checkType(this.$route.query.active, '');
  },
  computed: {
    ...mapGetters({
      defaultCompany: 'getDefaultCompany',
      isLoading: 'loading/getActiveSkeletons',
      currentPermission: 'permissions/getPermissions',
      userInformation: 'getUserInformation',
    }),
    theme() {
      return this.$store.state.theme;
    },
    isOwner() {
      return this.$store.state.permissions.isOwner;
    },
  },
  watch: {
    defaultCompany(val, oldVal) {
      if (val.id !== oldVal.id) this.onTabChange(this.currentType);
    },
    $route() {
      this.$store.dispatch('loading/skeletonLoader', { name: 'singleZone', status: true });
      this.$store.dispatch('loading/skeletonLoader', { name: 'subZones', status: true });
      this.$store.dispatch('loading/skeletonLoader', { name: 'devices', status: true });
      this.getSingleZone(this.$route.params.id);
      this.checkType(this.currentType, '');
    },
  },
  methods: {
    unlockDevice() {
      this.$store.commit('loading/DISABLE_HANDLER', true);
      axiosConfig
        .get(`/companies/${this.defaultCompany.id}/devices/${this.unlockDeviceId}/unlock`)
        .then(() => {
          this.closeModals('unlockDeviceModal');
          this.$toast.success(this.$t('unlocked_successfully', { device: this.unlockDeviceName }));
          this.$store.commit('loading/DISABLE_HANDLER', false);
        })
        .catch((error) => {
          this.closeModals('unlockDeviceModal');
          serverErrorsHandler(error);
          this.$store.commit('loading/DISABLE_HANDLER', false);
        });
    },
    closeModals(...modals) {
      modals.map((modalName) => this.$store.dispatch('modal/close', modalName));
    },
    unlockDeviceHandler(id, name, canUnlock) {
      this.unlockDeviceId = id;
      this.unlockDeviceName = name;
      if (canUnlock) {
        this.$store.dispatch('modal/open', 'unlockDeviceModal');
      }
    },
    backRouteHandler() {
      if (this.singleZone.parent_id && this.singleZone.parent_id !== null) {
        this.$router.push({
          name: 'SingleZone',
          params: {
            id: this.singleZone.parent_id,
          },
          query: { active: this.currentType },
        });
      } else {
        this.$router.push({
          name: 'ZonesPage',
        });
      }
    },
    resizer(image) {
      return imageResizer(image, this.imageSize);
    },
    hasPermission(permission) {
      return this.currentPermission.includes(permission);
    },
    zoneBackground(zone) {
      return zone.image != null ? zone.image : brokenSrc();
    },
    goToReservationRoom(item) {
      if (item.reservable === 1) {
        this.$router.push({ name: 'ConferenceRoom', params: { id: item.id } });
      } else {
        this.$router.push({ name: 'WorkRoom', params: { id: item.id } });
      }
    },
    onTabChange(type) {
      this.currentPage = 1;
      this.currentType = type;
    },
    checkType(type, text) {
      switch (type) {
        case 'subZones':
          this.getSubZones(text);
          break;
        case 'devices':
          this.getDevices(text);
          break;
        default:
          this.getSubZones(text);
          break;
      }
    },
    getSearchedType(type) {
      this.searchType = type;
    },
    getSearchedText(text) {
      this.isSearching = !!(text && text !== '');
      this.checkType(this.searchType, text);
    },
    getSingleZone(subZoneId) {
      this.zones = [];
      this.$store.dispatch('loading/skeletonLoader', { name: 'singleZone', status: true });
      axiosConfig
        .get(`/companies/${this.defaultCompany.id}/zones/${subZoneId}`)
        .then((response) => {
          this.singleZone = response.data.data;
          this.$store.dispatch('loading/skeletonLoader', { name: 'singleZone', status: false });
          this.$router
            .push({
              name: 'SingleZone',
              params: { id: subZoneId },
              query: { active: this.currentType },
            })
            .catch(() => {});
        });
    },
    getSubZones(searchedText) {
      this.$store.dispatch('loading/skeletonLoader', { name: 'subZones', status: true });
      axiosConfig
        .get(
          `/companies/${this.defaultCompany.id}/zones/${this.$route.params.id}?q=${
            searchedText || ''
          }&columns[]=name`,
        )
        .then((response) => {
          this.zones = response.data.data.zones;
          this.$store.dispatch('loading/skeletonLoader', { name: 'subZones', status: false });
        });
    },
    getDevices(searchedText) {
      this.$store.dispatch('loading/skeletonLoader', { name: 'devices', status: true });
      axiosConfig
        .get(
          `/companies/${this.defaultCompany.id}/zones/${
            this.$route.params.id
          }/get-devices?per_page=12&page=${this.currentPage}&q=${searchedText || ''}&columns[]=name`,
        )
        .then((response) => {
          this.devices = response.data.data;
          this.links = response.data.meta;
          this.$store.dispatch('loading/skeletonLoader', { name: 'devices', status: false });
        });
    },
    deleteSingleZone() {
      this.disabledButton = true;
      this.$store.commit('loading/LOADING_HANDLER', true);
      axiosConfig
        .delete(`/companies/${this.defaultCompany.id}/zones/${this.singleZone.id}`)
        .then(() => {
          this.disabledButton = false;
          this.$store.commit('loading/LOADING_HANDLER', false);
          modalSwitcher('delete', 'deleted-successfully', true);
          setTimeout(() => {
            this.$router
              .push({
                name: `${this.singleZone.parent_id ? 'SingleZone' : 'Dashboard'}`,
                params: {
                  id: this.singleZone.parent_id ? this.singleZone.parent_id : '',
                },
                query: { active: `${this.singleZone.parent_id ? 'subZones' : 'zones'}` },
              })
              .catch(() => {});
          }, 2000);
        })
        .catch((error) => {
          this.disabledButton = false;
          this.$store.commit('loading/LOADING_HANDLER', false);
          serverErrorsHandler(error);
          throw error;
        });
    },
    closeModal(name) {
      this.$store.dispatch('modal/close', name);
    },
    openModal(name) {
      this.$store.dispatch('modal/open', name);
    },
    onPageChange(page) {
      this.currentPage = page;
      this.getDevices();
    },
  },
};
</script>

<style scoped>
.center {
  @apply flex justify-center items-center;
}
.backgroundLayer {
  @apply w-full h-full top-0 left-0 rounded-bl-none rounded-br-none rounded-tl rounded-tr;
  background-color: rgba(0, 0, 0, 0.5);
}
.notification-box {
  @apply w-38 h-38 rounded flex items-center relative;
}
.company-info {
  @apply border-default border border-b-2 p-20 rounded-bl-none rounded-br-none
  bg-secondary rounded drop-shadow-dashboardLight
   relative rounded-tl rounded-tr
  bg-center bg-cover;
}
.company-tab {
  @apply pt-26 rounded-tl-none rounded-tr-none rounded-bl rounded-br
  bg-secondary rounded drop-shadow-dashboardLight relative;
}
.inner-dashboard-card {
  @apply px-24 py-10 rounded shadow-innerCard;
}
.grid-box:is(:lang(fa), :lang(ar)) {
  @apply flex gap-20 flex-row;
}
.grid-box {
  @apply flex gap-20 flex-row;
}
.logo-card {
  @apply h-128 w-128 border bg-secondary rounded col-span-2
    xl:col-span-1 lg:col-span-2 md:col-span-2 sm:col-span-3;
}
.dashed_border-info {
  @apply rounded px-16 py-5 text-center h-58;
}
.dashed_border-header {
  @apply block font-semibold text-white text-18;
}
.dashed_border-content {
  @apply block font-semibold text-white text-10 whitespace-nowrap;
}
.inner-logo-card {
  @apply p-16;
}
.back-arrow {
  @apply w-1/12 mt-8 z-10 flex flex-row cursor-pointer;
}
.column-arrange {
  @apply flex flex-col flex-wrap text-justify z-10 w-10/12;
}
.zone-menu {
  @apply justify-self-end w-1/12;
}
.zone-menu-alignment {
  @apply p-0 z-10;
}
.company-name {
  @apply text-24 font-bold text-white;
}
.company-description {
  @apply text-14 font-semibold text-subtitle;
}
.zone-caption {
  background: linear-gradient(
    0deg,
    #000000 0%,
    rgba(255, 255, 255, 0) 90.38%,
    rgba(255, 255, 255, 0) 90.38%
  );
}
.zone-card-text {
  @apply absolute text-24 text-white px-20 py-20 zone-caption w-full
  bottom-0 rounded h-1/2 flex flex-col justify-end;
}
.tab-title {
  @apply font-bold mb-1 text-24 leading-28;
}
.tab-description {
  @apply text-14 leading-16;
}
.tab-toolbar {
  @apply flex justify-between items-center gap-x-20 sm:flex-col sm:gap-y-20;
}
.device-card,
.zone-card {
  @apply grid grid-cols-4 xl:grid-cols-3 lg:grid-cols-2 md:grid-cols-2 sm:grid-cols-1 gap-30;
}
.member-card {
  @apply grid grid-cols-6 lg:grid-cols-6 md:grid-cols-4 sm:grid-cols-2 gap-30;
}
.zone-card-image {
  @apply rounded border border-default w-294 h-84
  flex flex-row items-center gap-x-10 p-12 cursor-pointer;
}
.zone-card-main {
  @apply relative cursor-pointer h-210 rounded border-2 border-default;
}
.device-card-main {
  @apply bg-secondary cursor-pointer h-128 w-294 rounded border border-default flex flex-col p-12;
}
.device-card-image {
  @apply w-110 h-110;
}
.member-card-main {
  @apply relative bg-secondary shadow-dashboardCard cursor-pointer h-180 rounded;
}
.member-card-text {
  @apply text-center;
}
.member-card-image {
  @apply w-88 h-88 rounded-full;
}
.card-header-icon-danger {
  @apply bg-danger;
}
.card-text-icon {
  @apply flex mt-20 justify-between;
}
.lock-icon {
  @apply m-auto w-16;
}
.green-lock {
  @apply w-40 h-40 rounded-full bg-success self-center shadow-icon flex;
}
.card-header-icon-success,
.card-header-icon-danger {
  @apply w-8 h-8 rounded-full opacity-40 self-center shadow-icon flex;
}
.card-header-icon-success {
  @apply bg-success;
}
.card-header-icon-danger {
  @apply bg-danger;
}
.card-text-icon {
  @apply flex mt-20 justify-between px-20;
}
.lock-icon {
  @apply m-auto w-16;
}
.popover_classes {
  @apply cursor-pointer flex justify-evenly items-center
  text-14 font-semibold text-title;
}
.popover-img {
  @apply w-30 px-4;
}
.popover-bottom-bordered {
  @apply border-b border-default text-center;
}
.popover-group_li {
  @apply px-20 py-10 my-5 transition-all duration-300 rounded;
}
.hover-popover-group_li {
  @apply hover:bg-secondary;
}
.popover-title {
  @apply text-subtitle text-12 font-semibold;
}
</style>
